// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { defineMessages, FormattedMessage, intlShape } from 'react-intl';
import { FormValidator } from '../../../../../utils/form';


import style from '../Payouts.scss';
import buttonStyle from '../../../../../assets/styles/button.scss';
import commonStyle from '../../../PreferencesViewCommon.scss';
import boxStyle from '../../../../../assets/styles/box.scss';
import formStyle from '../../../../../assets/styles/form.scss';
import inputStyle from '../../../../../assets/styles/input.scss';

type Props = {
  handleBack: (e: Event) => void;
  handleSubmit: (e: Event) => void;
  handleChange: (e: SyntheticInputEvent<HTMLInputElement>) => void;
  handleFocus: (e: Event) => void;
  isPostingPayout: boolean;
  email: {
    value: string;
    errors?: string[];
  };
};

const messages = defineMessages({
  button: {
    cancel: {
      id: 'preferences.payouts.button.cancel',
    },
    add: {
      id: 'preferences.payouts.button.add',
    },
  },
  email: {
    placeholder: {
      id: 'preferences.payouts.payPalAccount.placeholder',
    }
  }
});

export default class PayPalStep extends Component<Props> {

  render() {
    const { handleBack, handleSubmit, isPostingPayout, email, handleChange, handleFocus } = this.props;
    const emailError = email.errors && FormValidator.buildErrorLabel(email.errors, {
      required: 'preferences.payouts.payPalAccount.error.required',
      emailFormat: 'preferences.payouts.payPalAccount.error.emailFormat',
    });
    return (<section className={style.payPalStep}>
      <form className={classNames(formStyle.formWrap, style.payPalForm)}>
        <FormattedMessage
          id='preferences.payouts.stepPayPal.title'>{
          txt => <h2 className={classNames(boxStyle.boxTitle, style.title)}>{txt}</h2>
        }</FormattedMessage>
        <section className={classNames(formStyle.row, formStyle.inputRow, formStyle.dualWrap, formStyle.responsive)}>
          <article className={formStyle.col}>
            <FormattedMessage id='preferences.payouts.payPalAccount.label'>{
              txt => (<label className={formStyle.label}>{txt}</label>)
            }</FormattedMessage>
            <input disabled={isPostingPayout}
                   className={classNames(inputStyle.input,
                     { [inputStyle.red]: email.errors && email.errors.length },
                     { [inputStyle.lightBlue]: !!email.value })}
                   value={email.value}
                   onChange={handleChange}
                   onFocus={handleFocus}
                   name="email"
                   placeholder={this.context.intl.formatMessage(messages.email.placeholder)}/>
            {emailError}
          </article>
        </section>
      </form>
      <section className={classNames(commonStyle.buttonsRow, commonStyle.buttons)}>
        <FormattedMessage id={messages.button.cancel.id}>{
          txt => <button type="button"
                         disabled={isPostingPayout}
                         className={classNames(buttonStyle.btn, buttonStyle.darkGrey)}
                         onClick={handleBack}>
            {txt}</button>
        }</FormattedMessage>
        <FormattedMessage id={messages.button.add.id}>{
          txt => <button type="button"
                         disabled={isPostingPayout}
                         className={classNames(buttonStyle.btn, buttonStyle.lightBlue)}
                         onClick={handleSubmit}>
            {txt}</button>
        }</FormattedMessage>
      </section>
    </section>);
  }
}

PayPalStep.propTypes = {
  handleBack: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleFocus: PropTypes.func.isRequired,
  isPostingPayout: PropTypes.bool,
  email: PropTypes.object,
};

PayPalStep.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/preferences/payouts/components/PayPalStep/PayPalStep.jsx